import React from 'react'

const UploadTile = ({ label, preview, placeholder, onClick, variant = 'mobile' }) => {
  const desktop = variant === 'desktop'
  return (
    <button
      type="button"
      onClick={onClick}
      className={
        desktop
          ? 'group relative w-full min-h-[120px] rounded-xl border-2 border-dashed border-[#d0d7e2] bg-[#f7f9fc] hover:border-[#0099ff] hover:bg-[#f0f7ff] transition'
          : 'w-full aspect-square rounded-2xl bg-white overflow-hidden flex items-center justify-center shadow-sm'
      }
      aria-label={label}
    >
      {preview ? (
        <img src={preview} alt={label} className="h-full w-full object-cover rounded-xl" />
      ) : desktop ? (
        <div className="flex flex-col items-center gap-2 text-[#0099ff] font-semibold">
          <div className="h-9 w-9 rounded-full border-2 border-current flex items-center justify-center text-lg leading-none">+</div>
          <span className="text-sm text-gray-800">{label}</span>
        </div>
      ) : placeholder ? (
        <img src={placeholder} alt={label} className="h-full w-full object-cover" />
      ) : (
        <div className="flex flex-col items-center gap-1 text-[#0099ff] font-semibold">
          <div className="h-7 w-7 rounded-full border border-[#0099ff] flex items-center justify-center">+</div>
          <span className="text-xs">Foto</span>
        </div>
      )}
    </button>
  )
}

export default UploadTile
